"use client"

import { Component } from "react"
import { Mobile, PC, Tablet, Notebook } from "../../ReactiveMode"

class ChildrensMinistry extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        const logoUrl = `${process.env.REACT_APP_CDN_URL}/images/education/3.png`

        return (
            <section className="pf-page">
                <div className="childrens-ministry-clean-header">
                    <div className="header-container">
                        <div className="header-content">
                            <div className="header-icon">
                                <img src={logoUrl || "/placeholder.svg"} alt="유초등부 로고" />
                            </div>
                            <h1>유초등부</h1>
                            <p>하나님의 말씀 안에서 자라나는 믿음의 어린 나무</p>
                        </div>
                    </div>
                </div>

                <PC>
                    <div className="childrens-ministry-clean-content">
                        <div className="content-wrapper">
                            {/* 유초등부 소개 섹션 */}
                            <div className="section">
                                <div className="section-header">
                                    <h2>유초등부 소개</h2>
                                </div>
                                <div className="intro-card">
                                    <div className="card-content">
                                        <div className="icon-wrapper">
                                            <i className="fas fa-seedling"></i>
                                        </div>
                                        <div className="text-content">
                                            <p className="main-text">
                                                유초등부는 아이들이 복음을 이해하고, 자신의 믿음으로 고백하며 자라가는 시기입니다.
                                            </p>
                                            <p className="sub-text">
                                                기도, 예배, 성경공부를 통해 하나님의 성품을 배우고, 그 말씀대로 살아가고자 하는 마음이
                                                자라납니다. 우리 아이들이 말씀 위에 굳건히 서서 바람에도 흔들리지 않는 작은 나무로 자라도록 돕는
                                                것이 유초등부의 비전입니다.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* 표어 섹션 */}
                            <div className="section">
                                <div className="section-header">
                                    <h2>표어</h2>
                                </div>
                                <div className="motto-card">
                                    <div className="motto-content">
                                        <div className="motto-icon">
                                            <img src={logoUrl || "/placeholder.svg"} alt="유초등부 로고" />
                                        </div>
                                        <div className="motto-text">
                                            <span className="motto-main">지(知).구(救).력(力)</span>
                                            <span className="motto-sub">하나님을 아는 것이 구원받은 우리들의 힘!</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* 예배 안내 섹션 */}
                            <div className="section">
                                <div className="section-header">
                                    <h2>예배 안내</h2>
                                </div>
                                <div className="worship-grid">
                                    <div className="worship-card">
                                        <div className="worship-header">
                                            <div className="worship-icon">
                                                <i className="fas fa-church"></i>
                                            </div>
                                            <h3>주일 예배</h3>
                                        </div>
                                        <div className="worship-content">
                                            <div className="worship-info">
                                                <div className="info-item">
                                                    <i className="far fa-clock"></i>
                                                    <span>매주 주일 오전 11:30</span>
                                                </div>
                                                <div className="info-item">
                                                    <i className="fas fa-map-marker-alt"></i>
                                                    <span>성실교회 교육관 2층 유초등부실</span>
                                                </div>
                                                <div className="info-item">
                                                    <i className="fas fa-user-friends"></i>
                                                    <span>초등학생</span>
                                                </div>
                                            </div>
                                            <div className="worship-order-simple">
                                                <h4>예배 순서</h4>
                                                <p>
                                                    카운트다운 - 사도신경 - 찬양 - 입례송 - 대표기도 - 말씀 - 말씀 암송 챈트 - 헌금 - 주기도문 -
                                                    광고 - 점심식사 - 2부순서
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* 주제성구 섹션 */}
                            <div className="section">
                                <div className="section-header">
                                    <h2>주제성구</h2>
                                </div>
                                <div className="scripture-card">
                                    <div className="scripture-header">
                                        <div className="scripture-icon">
                                            <i className="fas fa-book-open"></i>
                                        </div>
                                        <h3>호세아 6:3</h3>
                                    </div>
                                    <div className="scripture-content">
                                        <p className="scripture-text">
                                            "그러므로 우리가 여호와를 알자 힘써 여호와를 알자 그의 나타나심은 새벽빛같이 어김 없나니 비와
                                            같이, 땅을 적시는 늦은 비와 같이 우리에게 임하시리라 하니라"
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {/* 교육목표 섹션 */}
                            <div className="section">
                                <div className="section-header">
                                    <h2>교육목표</h2>
                                </div>
                                <div className="goals-grid">
                                    <div className="goal-card">
                                        <div className="goal-header">
                                            <div className="goal-icon">
                                                <i className="fas fa-search"></i>
                                            </div>
                                            <h3>하나님을 아는 일에<br/>힘쓰는 어린이</h3>
                                        </div>
                                        <div className="goal-content">
                                            <p>
                                                참된 믿음은 분명한 지식과 확신 속에서 나옵니다. 우리 아이들이 매주 듣는 말씀과 공과 공부의
                                                시간을 통하여 하나님에 대한 올바른 지식을 소유하고, 그분에 대한 확신에 찬 고백을 가지기를
                                                원합니다. 그리하여 세상이 감당치 못할 믿음의 사람으로 자라기를 소원합니다.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="goal-card">
                                        <div className="goal-header">
                                            <div className="goal-icon">
                                                <i className="fas fa-heart"></i>
                                            </div>
                                            <h3>하나님을 삶에서 누리는<br/>어린이</h3>
                                        </div>
                                        <div className="goal-content">
                                            <p>
                                                하나님을 아는 지식은 단순한 앎이 아닙니다. 삶의 전부분에서 경험적으로 아는 것을 의미합니다. 우리
                                                아이들이 하나님을 삶 속에서 만나며, 누리는 어린이들이 되기를 소원합니다. 악하고 험한 이 세상을
                                                나의 힘과 능력으로 홀로 살아가는 것이 아니라 우리의 주인 되신 하나님과 동행하는 삶임을 깨닫는
                                                어린이들이 되기를 소원합니다.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="goal-card">
                                        <div className="goal-header">
                                            <div className="goal-icon">
                                                <i className="fas fa-hands-praying"></i>
                                            </div>
                                            <h3>지식에서 순종으로<br/>나아가는 어린이</h3>
                                        </div>
                                        <div className="goal-content">
                                            <p>
                                                하나님을 아는 지식은 반드시 삶에 영향을 미치게 되어 있습니다. 우리 아이들이 하나님의 말씀을
                                                듣고, 그 말씀대로 살아갈 수 있는 능력을 훈련하는 시간이 되기를 소원합니다. 그리하여 하나님 앞에
                                                기쁨이 되기를 원합니다.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </PC>

                <Notebook>
                    <div className="childrens-ministry-clean-content">
                        <div className="content-wrapper">
                            {/* 유초등부 소개 섹션 */}
                            <div className="section">
                                <div className="section-header">
                                    <h2>유초등부 소개</h2>
                                </div>
                                <div className="intro-card">
                                    <div className="card-content">
                                        <div className="icon-wrapper">
                                            <i className="fas fa-seedling"></i>
                                        </div>
                                        <div className="text-content">
                                            <p className="main-text">
                                                유초등부는 아이들이 복음을 이해하고, 자신의 믿음으로 고백하며 자라가는 시기입니다.
                                            </p>
                                            <p className="sub-text">
                                                기도, 예배, 성경공부를 통해 하나님의 성품을 배우고, 그 말씀대로 살아가고자 하는 마음이
                                                자라납니다.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* 표어 섹션 */}
                            <div className="section">
                                <div className="section-header">
                                    <h2>표어</h2>
                                </div>
                                <div className="motto-card">
                                    <div className="motto-content">
                                        <div className="motto-icon">
                                            <img src={logoUrl || "/placeholder.svg"} alt="유초등부 로고" />
                                        </div>
                                        <div className="motto-text">
                                            <span className="motto-main">지(知).구(救).력(力)</span>
                                            <span className="motto-sub">하나님을 아는 것이 구원받은 우리들의 힘!</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* 예배 안내 섹션 */}
                            <div className="section">
                                <div className="section-header">
                                    <h2>예배 안내</h2>
                                </div>
                                <div className="worship-grid">
                                    <div className="worship-card">
                                        <div className="worship-header">
                                            <div className="worship-icon">
                                                <i className="fas fa-church"></i>
                                            </div>
                                            <h3>주일 예배</h3>
                                        </div>
                                        <div className="worship-content">
                                            <div className="worship-info">
                                                <div className="info-item">
                                                    <i className="far fa-clock"></i>
                                                    <span>매주 주일 오전 11:30</span>
                                                </div>
                                                <div className="info-item">
                                                    <i className="fas fa-map-marker-alt"></i>
                                                    <span>성실교회 교육관 2층 유초등부실</span>
                                                </div>
                                                <div className="info-item">
                                                    <i className="fas fa-user-friends"></i>
                                                    <span>초등학생</span>
                                                </div>
                                            </div>
                                            <div className="worship-order-simple">
                                                <h4>예배 순서</h4>
                                                <p>
                                                    카운트다운 - 사도신경 - 찬양 - 입례송 - 대표기도 - 말씀 - 말씀 암송 챈트 - 헌금 - 주기도문 -
                                                    광고 - 점심식사 - 2부순서
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* 주제성구 섹션 */}
                            <div className="section">
                                <div className="section-header">
                                    <h2>주제성구</h2>
                                </div>
                                <div className="scripture-card">
                                    <div className="scripture-header">
                                        <div className="scripture-icon">
                                            <i className="fas fa-book-open"></i>
                                        </div>
                                        <h3>호세아 6:3</h3>
                                    </div>
                                    <div className="scripture-content">
                                        <p className="scripture-text">
                                            "그러므로 우리가 여호와를 알자 힘써 여호와를 알자 그의 나타나심은 새벽빛같이 어김 없나니 비와
                                            같이, 땅을 적시는 늦은 비와 같이 우리에게 임하시리라 하니라"
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {/* 교육목표 섹션 */}
                            <div className="section">
                                <div className="section-header">
                                    <h2>교육목표</h2>
                                </div>
                                <div className="goals-grid">
                                    <div className="goal-card">
                                        <div className="goal-header">
                                            <div className="goal-icon">
                                                <i className="fas fa-search"></i>
                                            </div>
                                            <h3>하나님을 아는 일에<br/>힘쓰는 어린이</h3>
                                        </div>
                                        <div className="goal-content">
                                            <p>
                                                참된 믿음은 분명한 지식과 확신 속에서 나옵니다. 우리 아이들이 매주 듣는 말씀과 공과 공부의
                                                시간을 통하여 하나님에 대한 올바른 지식을 소유하기를 원합니다.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="goal-card">
                                        <div className="goal-header">
                                            <div className="goal-icon">
                                                <i className="fas fa-heart"></i>
                                            </div>
                                            <h3>하나님을 삶에서 누리는<br/>어린이</h3>
                                        </div>
                                        <div className="goal-content">
                                            <p>
                                                우리 아이들이 하나님을 삶 속에서 만나며, 누리는 어린이들이 되기를 소원합니다. 하나님과 동행하는
                                                삶임을 깨닫는 어린이들이 되기를 소원합니다.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="goal-card">
                                        <div className="goal-header">
                                            <div className="goal-icon">
                                                <i className="fas fa-hands-praying"></i>
                                            </div>
                                            <h3>지식에서 순종으로<br/>나아가는 어린이</h3>
                                        </div>
                                        <div className="goal-content">
                                            <p>
                                                하나님을 아는 지식은 반드시 삶에 영향을 미치게 되어 있습니다. 우리 아이들이 하나님의 말씀을
                                                듣고, 그 말씀대로 살아갈 수 있는 능력을 훈련하는 시간이 되기를 소원합니다.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Notebook>

                <Tablet>
                    <div className="childrens-ministry-clean-content">
                        <div className="content-wrapper">
                            {/* 유초등부 소개 섹션 */}
                            <div className="section">
                                <div className="section-header">
                                    <h2>유초등부 소개</h2>
                                </div>
                                <div className="intro-card">
                                    <div className="card-content">
                                        <div className="icon-wrapper">
                                            <i className="fas fa-seedling"></i>
                                        </div>
                                        <div className="text-content">
                                            <p className="main-text">
                                                유초등부는 아이들이 복음을 이해하고, 자신의 믿음으로 고백하며 자라가는 시기입니다.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* 표어 섹션 */}
                            <div className="section">
                                <div className="section-header">
                                    <h2>표어</h2>
                                </div>
                                <div className="motto-card">
                                    <div className="motto-content">
                                        <div className="motto-icon">
                                            <img src={logoUrl || "/placeholder.svg"} alt="유초등부 로고" />
                                        </div>
                                        <div className="motto-text">
                                            <span className="motto-main">지(知).구(救).력(力)</span>
                                            <span className="motto-sub">하나님을 아는 것이 구원받은 우리들의 힘!</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* 예배 안내 섹션 */}
                            <div className="section">
                                <div className="section-header">
                                    <h2>예배 안내</h2>
                                </div>
                                <div className="worship-grid">
                                    <div className="worship-card">
                                        <div className="worship-header">
                                            <div className="worship-icon">
                                                <i className="fas fa-church"></i>
                                            </div>
                                            <h3>주일 예배</h3>
                                        </div>
                                        <div className="worship-content">
                                            <div className="worship-info">
                                                <div className="info-item">
                                                    <i className="far fa-clock"></i>
                                                    <span>매주 주일 오전 11:30</span>
                                                </div>
                                                <div className="info-item">
                                                    <i className="fas fa-map-marker-alt"></i>
                                                    <span>성실교회 교육관 2층 유초등부실</span>
                                                </div>
                                            </div>
                                            <div className="worship-order-simple">
                                                <h4>예배 순서</h4>
                                                <p>
                                                    카운트다운 - 사도신경 - 찬양 - 입례송 - 대표기도 - 말씀 - 말씀 암송 챈트 - 헌금 - 주기도문 -
                                                    광고 - 점심식사 - 2부순서
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* 주제성구 섹션 */}
                            <div className="section">
                                <div className="section-header">
                                    <h2>주제성구</h2>
                                </div>
                                <div className="scripture-card">
                                    <div className="scripture-header">
                                        <div className="scripture-icon">
                                            <i className="fas fa-book-open"></i>
                                        </div>
                                        <h3>호세아 6:3</h3>
                                    </div>
                                    <div className="scripture-content">
                                        <p className="scripture-text">"그러므로 우리가 여호와를 알자 힘써 여호와를 알자"</p>
                                    </div>
                                </div>
                            </div>

                            {/* 교육목표 섹션 */}
                            <div className="section">
                                <div className="section-header">
                                    <h2>교육목표</h2>
                                </div>
                                <div className="goals-grid tablet-goals">
                                    <div className="goal-card">
                                        <div className="goal-header">
                                            <div className="goal-icon">
                                                <i className="fas fa-search"></i>
                                            </div>
                                            <h3>하나님을 아는 일에<br/>힘쓰는 어린이</h3>
                                        </div>
                                    </div>
                                    <div className="goal-card">
                                        <div className="goal-header">
                                            <div className="goal-icon">
                                                <i className="fas fa-heart"></i>
                                            </div>
                                            <h3>하나님을 삶에서 누리는<br/>어린이</h3>
                                        </div>
                                    </div>
                                    <div className="goal-card">
                                        <div className="goal-header">
                                            <div className="goal-icon">
                                                <i className="fas fa-hands-praying"></i>
                                            </div>
                                            <h3>지식에서 순종으로<br/>나아가는 어린이</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Tablet>

                <Mobile>
                    <div className="childrens-ministry-clean-content">
                        <div className="content-wrapper">
                            {/* 유초등부 소개 섹션 */}
                            <div className="section">
                                <div className="section-header">
                                    <h2>유초등부 소개</h2>
                                </div>
                                <div className="intro-card">
                                    <div className="card-content">
                                        <div className="icon-wrapper">
                                            <i className="fas fa-seedling"></i>
                                        </div>
                                        <div className="text-content">
                                            <p className="main-text">
                                                유초등부는 아이들이 복음을 이해하고, 자신의 믿음으로 고백하며 자라가는 시기입니다.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* 표어 섹션 */}
                            <div className="section">
                                <div className="section-header">
                                    <h2>표어</h2>
                                </div>
                                <div className="motto-card">
                                    <div className="motto-content">
                                        <div className="motto-icon">
                                            <img src={logoUrl || "/placeholder.svg"} alt="유초등부 로고" />
                                        </div>
                                        <div className="motto-text">
                                            <span className="motto-main">지(知).구(救).력(力)</span>
                                            <span className="motto-sub">하나님을 아는 것이 구원받은 우리들의 힘!</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* 예배 안내 섹션 */}
                            <div className="section">
                                <div className="section-header">
                                    <h2>예배 안내</h2>
                                </div>
                                <div className="worship-grid">
                                    <div className="worship-card">
                                        <div className="worship-header">
                                            <div className="worship-icon">
                                                <i className="fas fa-church"></i>
                                            </div>
                                            <h3>주일 예배</h3>
                                        </div>
                                        <div className="worship-content">
                                            <div className="worship-info">
                                                <div className="info-item">
                                                    <i className="far fa-clock"></i>
                                                    <span>주일 오전 11:30</span>
                                                </div>
                                                <div className="info-item">
                                                    <i className="fas fa-map-marker-alt"></i>
                                                    <span>교육관 2층</span>
                                                </div>
                                            </div>
                                            <div className="worship-order-simple">
                                                <h4>예배 순서</h4>
                                                <p>
                                                    카운트다운 - 사도신경 - 찬양 - 입례송 - 대표기도 - 말씀 - 말씀 암송 챈트 - 헌금 - 주기도문 -
                                                    광고 - 점심식사 - 2부순서
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* 주제성구 섹션 */}
                            <div className="section">
                                <div className="section-header">
                                    <h2>주제성구</h2>
                                </div>
                                <div className="scripture-card">
                                    <div className="scripture-header">
                                        <div className="scripture-icon">
                                            <i className="fas fa-book-open"></i>
                                        </div>
                                        <h3>호세아 6:3</h3>
                                    </div>
                                    <div className="scripture-content">
                                        <p className="scripture-text">"그러므로 우리가 여호와를 알자 힘써 여호와를 알자"</p>
                                    </div>
                                </div>
                            </div>

                            {/* 교육목표 섹션 */}
                            <div className="section">
                                <div className="section-header">
                                    <h2>교육목표</h2>
                                </div>
                                <div className="goals-grid mobile-goals">
                                    <div className="goal-card">
                                        <div className="goal-header">
                                            <div className="goal-icon">
                                                <i className="fas fa-search"></i>
                                            </div>
                                            <h3>하나님을 아는 일에<br/>힘쓰는 어린이</h3>
                                        </div>
                                    </div>
                                    <div className="goal-card">
                                        <div className="goal-header">
                                            <div className="goal-icon">
                                                <i className="fas fa-heart"></i>
                                            </div>
                                            <h3>하나님을 삶에서 누리는<br/>어린이</h3>
                                        </div>
                                    </div>
                                    <div className="goal-card">
                                        <div className="goal-header">
                                            <div className="goal-icon">
                                                <i className="fas fa-hands-praying"></i>
                                            </div>
                                            <h3>지식에서 순종으로<br/>나아가는 어린이</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Mobile>
            </section>
        )
    }
}

export default ChildrensMinistry
